import React from "react";
import BlogSLider from "./BlogSlider";

export default function BlogDetailSLider() {
    return(
        <>
            <BlogSLider/>
        </>
    )
}